<template>
  <div class="w-full bg-white height-100">
    <el-dialog title="" :visible.sync="isShowDetailsAddons" width="35%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add Media
        </h3></template
      >
      <el-upload
        class="upload-demo"
        drag
        action="https://jsonplaceholder.typicode.com/posts/"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleUploadSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Drop file here or <em>click to upload</em>
        </div>
      </el-upload>
      <!-- <div class="my-2">
        <label class="mb-2">Alt image</label>
        <el-input placeholder="Please input" v-model="input"></el-input>
      </div> -->
      <!-- <div class="flex justify-center w-full mt-4">
        <vs-button
          variant="primary"
          class="rounded-lg bg-primary border-0 text-white font-semibold py-3 px-4 sm-fsize14"
        >
          Submit
        </vs-button>
      </div> -->
    </el-dialog>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Website Media
          </h2>
        </div>
      </div>
    </div>

    <div class="menucontrol-scroll fixed-top">
      <div class="py-6 px-8">
        <div class="flex justify-end w-full gap-4">
          <div>
            <el-select v-model="value" placeholder="Sort By">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <b-button
            variant="primary"
            @click="isShowDetailsAddons = true"
            class="px-item.mediatypemary rounded-item.mediatypehite py-3"
            >Add Media
          </b-button>
        </div>
        <div class="grid grid-cols-4 gap-4 mt-4">
          <div
            class="img_wrap justify-center"
            v-for="(item, index) in Fetchedmedias"
            :key="('item-', +index)"
            @click="ImageMedia = item"
          >
            <div class="w-full">
              <div
                v-if="item.type == 'svg' || item.type == 'image'"
                class="w-full relative"
              >
                <img
                  :src="url + '/' + item.link"
                  alt="image"
                  class="w-full tempselect-cs bg-gray object-cover rounded-lg"
                />
                <div class="absolute top-0 right-0 m-2">
                  <feather-icon
                    class="bg-white w-6 h-6 rounded-full flex justify-center items-center"
                    icon="XIcon"
                  />
                </div>
                <div class="absolute bottom-4 right-0 m-2">
                  <h1 class="text-lg text-white">9.1kb</h1>
                </div>
              </div>
              <div v-else class="w-full relative">
                <video
                  :src="url + '/' + item.link"
                  class="w-full tempselect-cs bg-gray object-cover rounded-lg"
                  controls
                ></video>
                <div class="absolute top-0 right-0 m-2">
                  <feather-icon
                    class="bg-white w-6 h-6 rounded-full flex justify-center items-center"
                    icon="XIcon"
                  />
                </div>
              </div>
            </div>
            <div class="absolute m-2 top-0 right-0">
              <feather-icon
                icon="XIcon"
                svgClasses="w-4 h-4"
                class="bg-white w-8 h-8 flex items-center shadow-lg justify-center cursor-pointer rounded-full"
                @click="DeleteMedia(item)"
              />
            </div>
          </div>
          <!-- <img
            src="@/assets/images/icons/Dashboard.svg"
            alt="grid"
            class="w-full tempselect-cs bg-gray rounded-lg"
          />
          <img
            src="@/assets/images/icons/Dashboard.svg"
            alt="grid"
            class="w-full tempselect-cs bg-gray rounded-lg"
          />
          <img
            src="@/assets/images/icons/Dashboard.svg"
            alt="grid"
            class="w-full tempselect-cs bg-gray rounded-lg"
          />
          <img
            src="@/assets/images/icons/Dashboard.svg"
            alt="grid"
            class="w-full tempselect-cs bg-gray rounded-lg"
          />
          <img
            src="@/assets/images/icons/Dashboard.svg"
            alt="grid"
            class="w-full tempselect-cs bg-gray rounded-lg"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      options: [
        {
          value: "Option1",
          label: "Option1",
        },
        {
          value: "Option2",
          label: "Option2",
        },
        {
          value: "Option3",
          label: "Option3",
        },
        {
          value: "Option4",
          label: "Option4",
        },
        {
          value: "Option5",
          label: "Option5",
        },
      ],
      value: "",

      isShowDetailsAddons: false,
      input: "",
      Fetchedmedias: [],
      url: this.$imageURL,
      damn: "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/undefined/0.6999380452795934",
    };
  },

  methods: {
    async DeleteMedia(item) {
      this.$swal
        .fire({
          title: "Alert",
          text: "Are you sure you want to delete the file?",
          icon: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#EA4Dff",
          cancelButtonColor: "  #6e7881",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await axios.post(
              process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Delete",
              {
                link: item.link,
              },
              {
                headers: {
                  "community-name": process.env.VUE_APP_COMMUNITY_NAME,
                },
              }
            );
          }
          await this.Fetchmedia();
        });
    },
    async Fetchmedia() {
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
    },

    async handleUploadSuccess(name) {
      this.isShowDetailsAddons = false;
      this.$swal({
        title: "Success!",
        text: `File ${name} uploaded`,
        customClass: {
          container: "my-sweetalert-container",
        },
        icon: "success",
        // timer: 2000,
        buttons: false,
      });
    },
    beforeUpload(file) {
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      formData.append("Storeendpoint", URL);
      this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      this.handleUploadSuccess(name);
    },
  },
  async mounted() {
    await this.Fetchmedia();
  },
};
</script>
